<a class="card" [title]="team?.slug" [routerLink]="['/', 'team', team?.slug] | localize">
  <div class="card__avatar">
    <span class="shape" [ngStyle]="{ 'background-color': team?.displayProfile?.family?.backgroundColor }"></span>
    <span class="shape" [ngStyle]="{ 'background-color': team?.displayProfile?.family?.backgroundColor }"></span>
    <img [src]="team | avatarUrl" [alt]="team?.seo?.title" [title]="team?.seo?.title" />
  </div>
  <h2 class="card__name">{{ team | displayTeamMember }}</h2>
  <p class="card__profile" [ngStyle]="{ color: team?.displayProfile?.family?.backgroundColor }">
    {{ team?.jobTitle || team?.displayProfile?.family?.name }}
  </p>
</a>
